var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.amenitiesBookings)?_c('bookings-list',{attrs:{"get-type-image":_vm.getTypeImage,"amenities-bookings":_vm.amenitiesBookings,"owners_association":_vm.owners_association}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }